import React, { useEffect, useState } from "react";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
// import Swal from "sweetalert2";
// import Dragger from "../../../../components/Dragger/Dragger";
// import { registrosService } from "../../../../_services/registros.service";
import { AbogadoService } from "../../../../_services/abogados.service";
import { ComunicacionesService } from "../../../../_services/comunicaciones.service";
// import { setLoading } from "../../../../redux/Loading/actions";
// import { useDispatch } from "react-redux";


const ComunicacionesModal = ({ show, handleClose, data={} }) => {
  const {
    register,
    handleSubmit,
    setValue
    // formState: { errors }
  } = useForm();
  // const [files, setFiles] = useState([]);
  const [abogadosList, setAbogadosList] = useState([]);
  // const dispatch = useDispatch();
  console.log("data -a-a- ",data);
  useEffect(() => {
    const getData = async () => {
      let response = await AbogadoService.getAbogadosNameDNI();
      if (response?.length) {
        setAbogadosList(response);
      }

    };

    getData();
  }, []);
  

  useEffect(() => {
    setTimeout(() => {
      if (data && data.todni) {
        console.log("entre al default value");
        setValue("todni", data.todni);
      }
    }, 200);
  }, [data, setValue]);

  // Precargar los valores cuando se recibe un "data" no vacío
  useEffect(() => {
    if (data) {
      setValue("titulo", data.titulo);
      setValue("todni", data.toAbogado?.nrodni);
      setValue("fecha", data.fecha);
      setValue("importancia", data.importancia);
      setValue("descripcion", data.descripcion);
    }
  }, [data, setValue]);

  // const onSubmit = async (data) => {
  //   try {
  //     console.log("data ", data)
  //     // return Swal.fire("Lo sentimos", "Esta funcionalidad aún  no esta implementada.", "info");
  //     // Swal.fire({
  //     //   title: "¿Esta seguro de guardar los cambios?",
  //     //   icon: "warning",
  //     //   showCancelButton: true,
  //     //   cancelButtonText: "No",
  //     //   confirmButtonColor: "#3085d6",
  //     //   cancelButtonColor: "#d33",
  //     //   confirmButtonText: "Si",
  //     //   reverseButtons: true,
  //     // }).then(async (result) => {
  //     //   if (result.isConfirmed) {
  //     //     dispatch(setLoading(true));
  //     //     let newData = new FormData();
  
  //     //     for (const prop in data) {
  //     //       newData.append(`${prop}`, data[prop]);
  //     //     }
  
  //     //     files.forEach((e) => {
  //     //       newData.append("files", e.originFileObj);
  //     //     });
  
  //         const res = await ComunicacionesService.createComunicacion(data);

  //     //     if (res.ok) {
  //     //       dispatch(setLoading(false));
  //     //       Swal.fire({
  //     //         title: "Exito!",
  //     //         icon: "success",
  //     //         didClose: () => handleClose()
  //     //       });
  //     //     }
  //     //     else {
  //     //       dispatch(setLoading(false));
  //     //       Swal.fire("Error!", "Ocurrio un error, intentelo nuevamente.", "error");
  //     //     }
  //     //   }
  //     // });
  //     handleClose()
  //   } catch (error) {
  //     console.log("comunicaciones onDubmit error", (error))
  //   }
  // };


  const onSubmit = async (formData) => {
    try {
      if (data?.id) {
        // Lógica para actualizar el registro existente
        await ComunicacionesService.updateComunicacionById(data.id, formData);
      } else {
        // Lógica para crear un nuevo registro
        await ComunicacionesService.createComunicacion(formData);
      }
      handleClose();
    } catch (error) {
      console.log("Error en el submit", error);
    }
  };

  return (
    <Modal
      animation={false}
      show={show}
      onHide={handleClose}
      size="xl"
    >
      <Modal.Header closeButton>
        {/* <Modal.Title>Nuevo Registro</Modal.Title> */}
        <Modal.Title>{data?.id ? "Editar Comunicación" : "Nueva Comunicación"}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex justify-content-center" >
        <Form className="abogado-form" onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase mb-2">Titulo: </Form.Label>
              <Form.Control
                name="titulo"
                {...register("titulo")}
              />
            </Col>
            {/* <Col xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase mb-2">Responsable: </Form.Label>
              <Form.Control
                name="usuario"
                {...register("usuario")}
              />
            </Col> */}

            <Col xl={6} md={6} className="mt-3">

              <Form.Label className="text-uppercase mb-2">Destinatario: </Form.Label>
              <Form.Control
                as="select"
                name="todni"
                {...register("todni")}
              >
                <option value="">Seleccione Destinatario</option>
                {
                  abogadosList.map((abogado) => {
                    return <option value={abogado.nrodni} key={abogado.nrodni}>{abogado.nombre_completo}</option>;
                  })
                }
              </Form.Control>


              {/* 
              <Form.Label className="text-uppercase mb-2">Destinatario: (hacer un select)</Form.Label>
              <Form.Control
                name="destinatarios"
                {...register("destinatarios")}
              /> */}
            </Col>
          </Row>

          <Row>
            
            <Col xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase mb-2">Fecha: </Form.Label>
              <Form.Control
                type="date"
                name="fecha"
                {...register("fecha", {
                  setValueAs: (v) => v && new Date(v).toISOString().split("T")[0],
                })}
              />
            </Col>
            <Col xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase mb-2">Importancia: </Form.Label>
              <Form.Control
                as="select"
                name="importancia"
                {...register("importancia")}
              >
                <option value="">Seleccione la importancia</option>
                <option value="urgente">Urgente</option>
                <option value="normal">Normal</option>
                <option value="informativa">Informativa</option>
              </Form.Control>
            </Col>
          </Row>

          <Row>
            <Col xl={12} md={12} className="mt-3">
              <Form.Label className="text-uppercase mb-2">Descripción</Form.Label>
              <Form.Control
                as="textarea"
                name="descripcion"
                rows={5}
                {...register("descripcion")}
              />
            </Col>
            {/* <Col xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase mb-2">Descripción: </Form.Label>
              <Form.Control
                name="descripcion"
                {...register("descripcion")}
              />
            </Col> */}
          </Row>

          {/* <Row>
            <Col xl={12} md={12} className="mt-3">
              <Form.Label className="text-uppercase mb-2">Descripción</Form.Label>
              <Form.Control
                as="textarea"
                name="descripcion"
                rows={5}
                {...register("descripcion")}
              />
            </Col>
          </Row> */}

          {/* <Row>
            <Col xl={12} md={12} className="mt-3">
              <Dragger setFiles={setFiles} />
            </Col>
          </Row> */}

          <Row className="justify-content-center pt-4">
            {/* <Button
              type="submit"
              style={{ maxWidth: 190 }}
              className="custom-button"
            >
              <span>Guardar</span>
            </Button> */}
            <Button type="submit">{data?.id ? "Actualizar" : "Guardar"}</Button>

            <Button
              className="danger-button ml-3"
              style={{ maxWidth: 190 }}
              variant="danger"
              onClick={handleClose}
            >
              <span>Cerrar</span>
            </Button>
          </Row>
        </Form>

      </Modal.Body>
    </Modal>
  );
};

export default ComunicacionesModal;
